import { Box, Typography } from "@material-ui/core";
import { Star } from "@material-ui/icons";
import React, { Fragment } from "react";

export default function SectionHeader({ currentPage, preHeading }) {
  var heading = currentPage;

  if (window.innerWidth <= 768) {
    heading = <div dangerouslySetInnerHTML={{ __html: currentPage }} />;
  } else {
    heading = heading
      ? heading.replaceAll("<br/>", "").replaceAll("<br>", "")
      : "";
  }
  return (
    <Box className="text-center">
      <Box className="pre-heading-star">
        <Star />
        <Star />
        <Star />
      </Box>
      <Typography component={"h3"} className="section-pre-heading">
        {preHeading}
      </Typography>
      <Typography component={"h1"} className="main-heading ">
        {heading}
      </Typography>
    </Box>
  );
}
